import { render, staticRenderFns } from "./sidebarThree.vue?vue&type=template&id=7acd7fa2&"
import script from "./sidebarThree.vue?vue&type=script&lang=js&"
export * from "./sidebarThree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports